import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#installation",
        "aria-label": "installation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Installation`}</h1>
    <p>{`Installing Vibranium is as easy as installing any npm module. All you need is `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/"
      }}>{`Node.JS`}</a>{` installed in your system.`}</p>
    <h2 {...{
      "id": "steps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#steps",
        "aria-label": "steps permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Steps`}</h2>
    <h3 {...{
      "id": "install-nodejs",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#install-nodejs",
        "aria-label": "install nodejs permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Install `}<a parentName="h3" {...{
        "href": "https://nodejs.org/en/"
      }}>{`Node.JS`}</a></h3>
    <p>{`  Head over to `}<a parentName="p" {...{
        "href": "https://nodejs.org/en/"
      }}>{`Node.JS`}</a>{` homepage and download the latest (Preferably LTS) installer file and install it in your system. To make sure it is installed properly, try running `}<inlineCode parentName="p">{`node --version`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm --version`}</inlineCode>{` in command line/terminal to see if they are working.`}</p>
    <h3 {...{
      "id": "install-vibranium",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#install-vibranium",
        "aria-label": "install vibranium permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Install Vibranium`}</h3>
    <p>{`  Open Command Line/Terminal in your system and run the following command`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install -g vibranium-cli
`}</code></pre>
    <p>{`  To see if the installation is successful, try running `}<inlineCode parentName="p">{`vib-cli --version`}</inlineCode>{` `}</p>
    <p>{`  Once you run install Vibranium, you'll have a CLI command (`}<inlineCode parentName="p">{`vib-cli`}</inlineCode>{`  alias `}<inlineCode parentName="p">{`vc`}</inlineCode>{` ) that you can use to execute Vibranium tasks. You can use either `}<inlineCode parentName="p">{`vib-cli`}</inlineCode>{`  or `}<inlineCode parentName="p">{`vc`}</inlineCode>{`, both give refer to the same command.`}</p>
    <blockquote>
      <p parentName="blockquote">{` `}<inlineCode parentName="p">{`vib-cli`}</inlineCode>{` or `}<inlineCode parentName="p">{`vc`}</inlineCode>{` in short is the command-line executable for Vibranium. Hereafter, I'll be referring to Vibranium commands with `}<inlineCode parentName="p">{`vc`}</inlineCode>{`, but you can use whichever you feel comfortable with.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Vibranium commands are globally available in your system. So you can run `}<inlineCode parentName="p">{`vib-cli`}</inlineCode>{` or `}<inlineCode parentName="p">{`vc`}</inlineCode>{` from any terminal irrespective of the directory the terminal points to.`}</p>
    </blockquote>
    <h3 {...{
      "id": "verify-the-installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#verify-the-installation",
        "aria-label": "verify the installation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Verify the Installation`}</h3>
    <p>{`There are a few important points that we can use to verify if the installation is successful.`}</p>
    <ol>
      <li parentName="ol">{`Make sure Node JS and npn are installed globally`}</li>
      <li parentName="ol">{`Make sure you are able to run the command `}<inlineCode parentName="li">{`vc`}</inlineCode>{` from any directory`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "1.2.collections_scenarios_endpoints.md"
      }}>{`Previous`}</a>{`
`}<a parentName="p" {...{
        "href": "1.4.configuration.md"
      }}>{`Next`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      